<template>
  <div class="bg-white position-relative d-flex flex-column" :class="{shadow: withShadow}">
    <div class="loader absolute" v-if="showLoader && loading"></div>
    <template v-if="empty">
      <p style="margin-top: 40%;" class="text-center">Selectionner un utilisateur pour démarrer une discussion <br>
        <i class="ti-comments text-green mt-3 d-block d-md-none" style="font-size: 50px" @click="$emit('toggle')"></i>
      </p>
    </template>
    <template v-else>
      <div v-if="hasTitle" v-b-toggle.collapse-chat
           class="d-flex p-2 justify-content-between message-title align-items-center bg-dark text-white">
        <div>
          <img style="height: 20px" src="@img/discussion1.svg" alt="">
          <span class="ml-2 fz-16">Discussions</span>
        </div>
        <i class="ti-angle-up when-open hover-primary"></i>
        <i class="ti-angle-down when-closed hover-primary"></i>
      </div>
      <div v-if="user" class="user-header">
        <i class="ti-arrow-left mr-2 d-block d-md-none" @click="$emit('toggle')"></i>
        <img :src="user.avatar" class="avatar" alt="">
        <span class="ml-3">{{ user.full_name }}</span>
      </div>
      <b-collapse :visible="visible" @shown="scrollDown" id="collapse-chat" class="collapse-chat">
        <div class="fz-12 pt-2 message-container overflow-auto px-2 flex-grow-1" ref="container"
             :class="{limited: !mobile}">
          <template v-for="(message, indextr) in messages">
            <template v-if="showDate(indextr)">
              <p class="small text-center mb-2">{{ displayDay(message.time) }}</p>
            </template>
            <message :ref="'message'+message.id" v-on:goto="goto" :message="message" :responses="responses(message.id)"
                     @click.native="()=> log"
                     v-on:reply="reply(message)"
                     :key="indextr"/>
          </template>
          <p class="text-center my-3" v-if="messages.length===0&&!loading">Aucun message disponible</p>
        </div>
        <message-editor ref="editor" class="mt-2 pb-1 message-editor" :class="{limited: !mobile}"
                        v-on:go_down="scrollDown"
                        :discussion-id="discussionId"
                        :user="user"/>
      </b-collapse>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import {mapGetters, mapState} from "vuex";
import Message from "@/components/Chat/Message";
import MessageEditor from "@/components/Chat/MessageEditor";

export default {
  name: 'ChatWidget',
  components: {MessageEditor, Message},
  props: {
    discussionId: {type: Number | String},
    user: {type: Object},
    hasTitle: {default: true},
    withShadow: {default: true},
    presence: {default: true},
    showLoader: {default: false, type: Boolean},
    visible: {default: false, type: Boolean}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    id() {
      return this.discussionId || (this.user && this.user.discussion_id)
    },
    ...mapGetters({discussions: 'chat/discussions', mobile: 'mobile'}),
    allMessages() {
      return this.discussions[this.id] || []
    },
    messages() {
      return this.allMessages.filter(m => m.response_to == null)
    },
    empty() {
      return !this.discussionId && !this.user
    }
  },
  watch: {
    user() {
      this.loadData()
    },
  },
  methods: {
    moment,
    responses(id) {
      return this.allMessages.filter(m => m.response_to && m.response_to.id === id)
    },
    showDate(index) {
      if (index === 0) return true
      if (this.messages[index - 1].time.isSame(this.messages[index].time, 'day')) return false
      return true
    },
    displayDay(time) {
      if (time.isSame(moment(), 'day')) return "Aujourd'hui"
      return time.format('ll')
    },
    log(e) {
      console.log(e.target.offsetTop)
    },
    goto(id) {
      const container = this.$refs.container
      let el = this.$refs['message' + id]
      if (!el) return
      el = el[0].$el
      container.scrollTo(0, el.offsetTop + 2 - el.offsetHeight)
      console.log(el, container)
    },
    loadData() {
      if (!this.id || (this.user && this.user.loaded)) return
      this.loading = true
      if (this.user) this.user.loaded = true
      this.$store.dispatch('chat/fetchDiscussion', this.id)
        .then(() => {
          // this.$nextTick(() => this.scrollDown())
        })
        .finally(() => this.loading = false)
    },
    scrollDown() {
      const container = this.$refs.container
      container.scrollTop = container.scrollHeight;
    },
    reply(message) {
      this.$refs.editor.reply(message)
    }
  },
  created() {
    this.loadData();
    if (this.presence) {
      Echo.join(`discussion.${this.discussionId}`)
        .here((users) => {
          //
        })
        .joining((user) => {
          console.log(user.name);
        })
        .leaving((user) => {
          console.log(user.name);
        })
        .listen('DiscussionMessageEvent', (message) => {
          if (this.messages) this.$store.commit('chat/APPEND_MESSAGE', message.chat)
        });
    }
  },
  beforeDestroy() {
    if (this.presence) window.Echo.leave(`discussion.${this.discussionId}`)
  }
};
</script>

<style lang="scss" scoped>
.message-container {
  background: $gray;
  flex-grow: 1;
  height: calc(100vh - 200px);

  &.limited {
    height: calc(100vh - 100px - 200px);
  }
}

.message-editor.limited {
  max-height: 130px;
  overflow-y: auto;
}

.message-title:hover {
  outline: none;
}

.user-header {
  height: 60px;
  display: flex;
  padding: 5px 10px;
  align-items: center;
}

.collapse-chat {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
